import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    arenaList: [],
    totalCount: 0,
    rankList: [],
    currentRank: []
  },
  mutations: {
    setData(state, payload) {
      state[payload.key] = payload.value;
    }
  },
  getters: {},
  actions: {
    getArenaList({ commit }, query) {
      api.getArenaList(query).then(({ data }) => {
        if(data) {
          commit('setData', {
            key: 'arenaList',
            value: data.list
          });
          commit('setData', {
            key: 'totalCount',
            value: data.totalCount
          });
        }
      });
    },
    create({ commit }, query) {
      return api.create(query);
    },
    getDetail({ commit }, query) {
      return api.getDetail(query);
    },
    update({ commit }, query) {
      return api.update(query);
    },
    updateStatus({ commit }, query) {
      return api.updateStatus(query);
    },
    getRankList({ commit }, query) {
      commit('setData', {
        key: 'rankList',
        value: []
      });
      api.getRankList(query).then(({ data }) => {
        if(data) {
          commit('setData', {
            key: 'rankList',
            value: data
          });
        }
      });
    },
    getCurrentRank({ commit }, query) {
      commit('setData', {
        key: 'currentRank',
        value: []
      });
      api.getCurrentRank(query).then(({ data }) => {
        if(data) {
          commit('setData', {
            key: 'currentRank',
            value: data
          });
        }
      });
    },
    editRank({ commit }, query) {
      return api.editRank(query);
    },
  }
};

appStore.registerModule('arena', store);
